import React from 'react';

export const ChevronDownIcon = props => {
  return (
    <span
      className="solstice-icon- solstice-icon-chevron-down"
      style={props.style || { color: '#757575', transform: 'scale(0.7)' }}
      id="down-icon"
    />
  );
};
